import { createSlice } from '@reduxjs/toolkit';

export const responsableSliceKey = 'responsableState';

const initialState = {
  allResponsables: [],
  isLoading: false,
  error: null
};

const { actions, reducer } = createSlice({
  name: responsableSliceKey,
  initialState,
  reducers: {
    // Acciones para solicitar responsables
    fetchResponsablesRequested(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchResponsablesSucceeded(state, { payload }) {
      state.allResponsables = payload;
      state.isLoading = false;
      state.error = null;
    },
    fetchResponsablesFailed(state, { payload }) {
      state.isLoading = false;
      state.error = payload;
    },

    // Acciones para actualizar responsables
    addResponsable(state, { payload }) {
      state.allResponsables.push(payload);
    },
    updateResponsable(state, { payload }) {
      const index = state.allResponsables.findIndex(
        (responsable) => responsable.id === payload.id
      );
      if (index !== -1) {
        state.allResponsables[index] = payload;
      }
    },
    removeResponsable(state, { payload }) {
      state.allResponsables = state.allResponsables.filter(
        (responsable) => responsable.id !== payload
      );
    },

    // Acción para limpiar los responsables
    clearResponsables(state) {
      state.allResponsables = [];
    },

    // Acción para asignar responsables a una actividad
    assignResponsablesToActivity() {
      // Esta acción es para documentación - la implementación real se maneja en sagas
    }
  }
});

// Selectores
const baseSelector = (state) => state[responsableSliceKey];

export function getAllResponsablesSelector(state) {
  return baseSelector(state).allResponsables;
}

export function getResponsableByIdSelector(state, responsableId) {
  return baseSelector(state).allResponsables.find(
    (responsable) => responsable.id === responsableId
  );
}

export function getResponsablesLoadingSelector(state) {
  return baseSelector(state).isLoading;
}

export function getResponsablesErrorSelector(state) {
  return baseSelector(state).error;
}

// Exportaciones
export const responsableReducer = reducer;
export const {
  fetchResponsablesRequested,
  fetchResponsablesSucceeded,
  fetchResponsablesFailed,
  addResponsable,
  updateResponsable,
  removeResponsable,
  clearResponsables,
  assignResponsablesToActivity
} = actions;
